import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
  href?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth,
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-bold rounded-xl transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 text-center';
  const variants = {
    primary: 'bg-teal-600 text-white hover:bg-teal-700 focus:ring-teal-500 shadow-lg shadow-teal-600/30',
    secondary: 'bg-amber-500 text-slate-900 hover:bg-amber-400 focus:ring-amber-500 shadow-lg shadow-amber-500/30',
    outline: 'border-2 border-slate-200 text-slate-700 hover:border-slate-300 hover:bg-slate-50 focus:ring-slate-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const Wrapper = motion.div;
  if (href) {
    return <Wrapper whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={fullWidth ? 'w-full block' : 'inline-block'} data-id="element-330">
        <a href={href} className={classes} data-id="element-331">
          {children}
        </a>
      </Wrapper>;
  }
  return <Wrapper whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={fullWidth ? 'w-full block' : 'inline-block'} data-id="element-332">
      <button className={classes} {...props} data-id="element-333">
        {children}
      </button>
    </Wrapper>;
}